<div mat-dialog-title align='center'>Create New {{getGroupTypeName()}}</div>
<div mat-dialog-content align='center'>
  <mat-form-field>
    <mat-label>Name</mat-label>
    <input matInput [(ngModel)]="name" placeholder="Name" required>
  </mat-form-field>
  <mat-form-field *ngIf='isLeagueOrTrip()'>
      <mat-label>Start Date</mat-label>
      <input matInput [matDatepicker]="picker" [(ngModel)]="startDate" placeholder="Start Date" ng-model-options="{ timezone: 'utc' }" (ngModelChange)='setEndDate()'>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  <mat-form-field *ngIf='isLeagueOrTrip()'>
    <mat-label>End Date</mat-label>
    <input matInput [matDatepicker]="picker2" [(ngModel)]="endDate" placeholder="End Date" disabled>
    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
    <mat-datepicker #picker2></mat-datepicker>
</mat-form-field>
  <div mat-dialog-content class='s18-font'>
    <span *ngIf='message'>{{message}}</span>
  </div>
</div>
<div mat-dialog-actions align="center">
  <button mat-raised-button color='accent' (click)="createGroup()" tabindex="2">Create  {{getGroupTypeName()}}
    <i *ngIf='sendingRequest' class='fa fa-spinner fa-spin fa-fw'></i>
  </button>
  <button mat-button mat-dialog-close tabindex="-1">Nevermind</button>
</div>